export default "__VITE_ASSET__f4XrQIgj__"